import i18next from 'i18next';

i18next.addResources('es', 'SubscriptionGate', {
  title: 'Suscríbase para seguir usando Ubuntulaw',
  description:
    'Su prueba gratuita o su suscripción ha finalizado. Adhiérase a un plan para continuar su gestión profesional.',
  adminDescription:
    'La prueba gratuita o la suscripción de su espacio de trabajo ha finalizado. Solicite al propietario que adhiera un plan para continuar.',
  seePlans: 'Ver planes disponibles',
  goToWorkspace: 'Ir al espacio de trabajo'
});
